import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { PermissionService } from 'src/app/auth/services/permission.service';
import { DISPLAY_ACCESS } from 'src/app/auth/types/access-level';

@Component({
  selector: 'install',
  templateUrl: './install.component.html',
  styleUrl: './install.component.scss',
  standalone: false,
})
export class InstallComponent {
  constructor(
    public location: Location,
    private readonly permissionService: PermissionService,
  ) {}

  get hasDisplayFullAccess(): boolean {
    return this.permissionService.hasAccess(DISPLAY_ACCESS.FULL_ACCESS);
  }
}
